/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { HintHelpers, HintHelpersInterface } from "../HintHelpers";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_sortedTrovesAddress",
        type: "address",
      },
    ],
    name: "SortedTrovesAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address",
      },
    ],
    name: "TroveManagerAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newAddress",
        type: "address",
      },
    ],
    name: "VaultParametersBaseChanged",
    type: "event",
  },
  {
    inputs: [],
    name: "DECIMAL_PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ETH_REF_ADDRESS",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "NAME",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_coll",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_debt",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
    ],
    name: "computeCR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_coll",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_debt",
        type: "uint256",
      },
    ],
    name: "computeNominalCR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_CR",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_numTrials",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_inputRandomSeed",
        type: "uint256",
      },
    ],
    name: "getApproxHint",
    outputs: [
      {
        internalType: "address",
        name: "hintAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "diff",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "latestRandomSeed",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getEntireSystemColl",
    outputs: [
      {
        internalType: "uint256",
        name: "entireSystemColl",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getEntireSystemDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "entireSystemDebt",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_VSTamount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maxIterations",
        type: "uint256",
      },
    ],
    name: "getRedemptionHints",
    outputs: [
      {
        internalType: "address",
        name: "firstRedemptionHint",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "partialRedemptionHintNICR",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "truncatedVSTamount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_sortedTrovesAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vaultParametersAddress",
        type: "address",
      },
    ],
    name: "setAddresses",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vaultParams",
        type: "address",
      },
    ],
    name: "setVestaParameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "sortedTroves",
    outputs: [
      {
        internalType: "contract ISortedTroves",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "troveManager",
    outputs: [
      {
        internalType: "contract ITroveManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vestaParams",
    outputs: [
      {
        internalType: "contract IVestaParameters",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type HintHelpersConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: HintHelpersConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class HintHelpers__factory extends ContractFactory {
  constructor(...args: HintHelpersConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<HintHelpers> {
    return super.deploy(overrides || {}) as Promise<HintHelpers>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): HintHelpers {
    return super.attach(address) as HintHelpers;
  }
  override connect(signer: Signer): HintHelpers__factory {
    return super.connect(signer) as HintHelpers__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): HintHelpersInterface {
    return new utils.Interface(_abi) as HintHelpersInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): HintHelpers {
    return new Contract(address, _abi, signerOrProvider) as HintHelpers;
  }
}
